//新增任务项目数据
export const ADD_TASK_LIST = 'ADD_TASK_LIST';

//新增选中项目的任务列表
export const ADD_TASK_ITEM = 'ADD_TASK_ITEM';

//更改当前选中的任务项目名称
export const UPDATE_ACTIVE_TASK_LIST_TYPE = 'UPDATE_ACTIVE_TASK_LIST_TYPE';

//更改当前选中的任务类别名称
export const UPDATE_ACTIVE_TASK_ITEM_TYPE = 'UPDATE_ACTIVE_TASK_ITEM_TYPE';

//更改当前选中的任务项目名称和当前选中项目类型名称
export const UPDATE_ALL_ACTIVE_TASK_TYPE = 'UPDATE_ALL_ACTIVE_TASK_TYPE';

//更新当前传递的任务详情数据
export const UPDATE_TASK_ITEM = 'UPDATE_TASK_ITEM';

//更新已完成多条任务详情数据
export const UPDATE_COMPLETE_TASK_ITEM = 'UPDATE_COMPLETE_TASK_ITEM';

//删除当前任务详情数据
export const DELETE_TASK_ITEM = 'DELETE_TASK_ITEM';

//编辑当前任务详情数据
export const EDIT_TASK_ITEM = 'EDIT_TASK_ITEM';

//退出登陆
export const LOGOUT_TASK = 'LOGOUT_TASK';


// WEBPACK FOOTER //
// ./src/store/modules/task/taskTypes.js